import React, { useState, useEffect } from 'react';

import { Modal, Spinner } from 'triider-components';
import { sendVerificationEmail, unifyUsers, getUserById } from 'services/api/auth';
import { getErrorMessage } from 'utils/filters';
import { ButtonModal, ButtonBack } from 'components/Button';
import { connect } from 'react-redux';
import { Creators as AuthCreators } from 'store/ducks/auth';
import { Creators as UiCreators, growlTypes } from 'store/ducks/ui';
import { colors } from '../../styles/stylesheets';

import {
  Container,
  HeaderImage,
  TitleModal,
  Label,
  TextBody,
  EmailUserStyled,
  ContentButtons,
  SendLinkEmail,
  ContentButton,
  Input,
  InformLogin,
  ContainerSpinner,
  LoginCustom,
} from './styles';

function ModalVerificationEmail({
  open,
  emailUser,
  documentUser,
  _updateTriiderUser,
  _growl,
  haveAccount,
  _updateUserLogin,
  userId,
}) {
  const [email, setEmail] = useState(emailUser);
  const [isEmailFake, setIsEmailFake] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isLogged, setIsLogged] = useState(false);
  const [disabledNextEmail, setDisabledNextEmail] = useState(true);
  const [closeModal, setCloseModal] = useState(false);
  const [stepEmail, setStepEmail] = useState(1);

  useEffect(() => {
    if (emailUser && documentUser === emailUser.split('@partners.com')[0]) {
      setIsEmailFake(true);
      setEmail('');
      setStepEmail(3);
    } else {
      setStepEmail(1);
    }
  }, []);

  useEffect(() => {
    if (email && email.match(/^\S+@\S+$/)) {
      setDisabledNextEmail(false);
    } else {
      setDisabledNextEmail(true);
    }
  }, [email]);

  const loginSuccess = async (data) => {
    try {
      setLoader(true);
      if (data.user.id === userId) {
        throw new Error('Usuário logado é o mesmo da agência virtual!');
      }
      const dataUnify = await unifyUsers(data.user.id, userId);
      _updateUserLogin(data);
      setIsLogged(true);
      setStepEmail(2);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      _growl(`Erro: ${getErrorMessage(error)}`, growlTypes.GROWL_ERROR);
    }
  };

  const verifyIsValidateEmail = async () => {
    try {
      setLoader(true);
      const { user } = await getUserById(userId);
      setLoader(false);
      if (user.partners_email_validated) {
        setCloseModal(true);
        _growl('Email validado com sucesso!', growlTypes.GROWL_SUCCESS);
      } else {
        _growl('Email não validado!', growlTypes.GROWL_ERROR);
      }
    } catch (error) {
      _growl(`Erro: ${getErrorMessage(error)}`, growlTypes.GROWL_ERROR);
      setLoader(false);
    }
  };

  const sendEmailAndGoStep = async (step = false) => {
    try {
      setLoader(true);

      if (stepEmail === 3 && emailUser !== email) {
        await _updateTriiderUser({
          fields: {
            email,
          },
        });
      }
      await sendVerificationEmail(email);

      if (step && step !== 'close') {
        setStepEmail(step);
      } else if (step === 'close') {
        setCloseModal(true);
      }
      setLoader(false);
    } catch (error) {
      try {
        // caso alterar email e email não está na base
        if (!(stepEmail === 3 && emailUser !== email)) {
          await _updateTriiderUser({
            fields: {
              email,
            },
          });
        }
        setStepEmail(2);
        await sendVerificationEmail(email);
        setLoader(false);
      } catch (error2) {
        setLoader(false);
        _growl(`Erro: ${getErrorMessage(error2)}`, growlTypes.GROWL_ERROR);
      }
    }
  };

  const handleGoBack = () => {
    if (stepEmail === 3) {
      setStepEmail(1);
    } else if (stepEmail === 2 && (!haveAccount || isLogged)) {
      setStepEmail(1);
    } else if (stepEmail === 2) {
      setStepEmail(3);
    }
  };
  return (
    <Modal open={open && !closeModal} close={() => false} isAskExit theme="newPartner">
      <Container>
        <ContentButton>
          <ButtonBack
            none={stepEmail === 1 || (isEmailFake && stepEmail === 3)}
            onClick={handleGoBack}
            type="button"
          >
            <span>Voltar</span>
          </ButtonBack>

          <HeaderImage />
        </ContentButton>
        {haveAccount && stepEmail === 2 && (
          <InformLogin>
            Identificamos que esse e-mail já possui uma conta no Triider. Por favor realize o login
            ou recupere sua senha.
          </InformLogin>
        )}
        {loader ? (
          <ContainerSpinner>
            <Spinner size="larger" />
          </ContainerSpinner>
        ) : (
          <>
            {stepEmail === 1 && (
              <>
                <TitleModal>Este é o seu e-mail?</TitleModal>
                <TextBody>
                  Este é o e-mail registrado na plataforma. Ele está vinculado à sua conta na
                  imobiliária. As informações do seu pedido (orçamentos, mensagens, etc) serão
                  enviadas para este endereço de e-mail. Você deseja confirmar?
                </TextBody>
                <EmailUserStyled>{email}</EmailUserStyled>

                <ContentButtons>
                  <ButtonModal onClick={() => sendEmailAndGoStep(2)} type="button">
                    SIM
                  </ButtonModal>
                  <ButtonModal
                    onClick={() => setStepEmail(3)}
                    bgColor={colors.white}
                    border={`${colors.primary} solid 2px`}
                    color={colors.primary}
                    type="button"
                  >
                    NÃO
                  </ButtonModal>
                </ContentButtons>
              </>
            )}
            {haveAccount && stepEmail === 2 && (
              <LoginCustom
                defaultEmail={email}
                hasFacebookLogin={false}
                onClickForgotPassword={() => window.open(`${process.env.SITE_PATH}u/recuperar`)}
                dispatchSuccess={data => loginSuccess(data)}
                dispatchError={error => _growl(`Erro: ${error}`, growlTypes.GROWL_ERROR)}
              />
            )}
            {(!haveAccount || isLogged) && stepEmail === 2 && (
              <>
                <TitleModal>Ótimo!</TitleModal>
                <TextBody>
                  Enviamos um
                  {' '}
                  <strong>link de verificação para validar o seu e-mail</strong>
                  {' '}
                  - é
                  necessário validar o e-mail para continuar, pois você
                  {' '}
                  <strong>
                    receberá todas as informações sobre a solicitação do serviço através deste canal
                  </strong>
                  . Verifique a sua caixa de spam ou clique para enviar novamente. Após acessar o
                  link de verificação, clique no
                  {' '}
                  <strong>Já validei meu e-mail</strong>
                  {' '}
                  para prosseguir.
                </TextBody>
                <SendLinkEmail onClick={() => sendEmailAndGoStep(2)}>
                  Enviar link de verificação novamente
                </SendLinkEmail>

                <ContentButtons>
                  <ButtonModal
                    onClick={verifyIsValidateEmail}
                    bgColor={colors.white}
                    color={colors.primary}
                    type="button"
                    width="60%"
                  >
                    Já validei meu e-mail
                  </ButtonModal>
                </ContentButtons>
              </>
            )}

            {stepEmail === 3 && (
              <>
                {isEmailFake ? (
                  <>
                    <TitleModal>Precisamos do seu Email!</TitleModal>
                    <TextBody>
                      Você deve
                      {' '}
                      <span>cadastrar um e-mail</span>
                      {' '}
                      para solicitar e acompanhar os
                      pedidos de orçamentos no
                      {' '}
                      <b>Triider</b>
                      !
                    </TextBody>
                  </>
                ) : (
                  <>
                    <TitleModal>Sem problemas!</TitleModal>
                    <TextBody>
                      Informe o seu e-mail para que possamos enviar todas as informações sobre os
                      seus pedidos para você!
                    </TextBody>
                  </>
                )}

                <Label>E-mail</Label>
                <Input type="email" value={email} onChange={e => setEmail(e.target.value)} />

                <ContentButtons>
                  <ButtonModal
                    width="60%"
                    disabled={disabledNextEmail}
                    onClick={() => sendEmailAndGoStep(2)}
                    type="button"
                    bgColor={disabledNextEmail ? colors.greyLight : colors.primary}
                  >
                    Próximo
                  </ButtonModal>
                </ContentButtons>
              </>
            )}
          </>
        )}
      </Container>
    </Modal>
  );
}

const mapStateToProps = state => ({
  haveAccount: state.auth.haveAccount,
  userId: state.auth.triiderUser.user && state.auth.triiderUser.user.id,
});
const mapDispatchToProps = {
  _updateTriiderUser: AuthCreators.updateTriiderUser,
  _setHaveAccount: AuthCreators.setHaveAccount,
  _updateUserLogin: AuthCreators.updateUserLogin,
  _growl: UiCreators.growl,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalVerificationEmail);
